import { render, staticRenderFns } from "./CabinetView.vue?vue&type=template&id=6c98d983&scoped=true"
import script from "./CabinetView.vue?vue&type=script&lang=js"
export * from "./CabinetView.vue?vue&type=script&lang=js"
import style0 from "./CabinetView.vue?vue&type=style&index=0&id=6c98d983&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c98d983",
  null
  
)

export default component.exports